<template>
    <div id='app' class="chart">
        <WordCloudChart 
        :data="chartData"
        
      />
    </div>
</template>



<script>
import {   WordCloudChart
  //...
} from 'dr-vue-echarts';

export default {
  components: {
    WordCloudChart
  },
  props: {
            chartData: {
                type: Array,
                default: () => {
                    return [];
                }
            },
      chart: null
    },
     data () {
            return {
                chartsLib: null,
                test: [
            { name: '2010', value: 8 },
            { name: '2011', value: 10 },
            { name: '2012', value: 12 },
            { name: '2013', value: 7 },
            { name: '2014', value: 9 },
            { name: '2015', value: 16 },
            { name: '2016', value: 15 },
            { name: '2017', value: 18 },
            { name: '2018', value: 20 },
            { name: '2019', value: 5 },
            { name: '2020', value: 9 },
          ]
                // Array will be automatically processed with visualization.arrayToDataTable function

            };
        }
  // ...
};
</script>
<style scoped>
.chart {
  width: 100%;
  height: 300px;
}
</style>
